src/views/summary-report/SummaryNepaleseAdReport.vue<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">NID Number Check</h3>
      </v-flex>
      <v-flex lg12>
        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex md4 xs12>
              <v-text-field
                :elevation="0"
                flat
                hide-details
                placeholder="NID Number"
                prepend-inner-icon="mdi-card-account-details"
                solo
                v-model="nid"
              ></v-text-field>
            </v-flex>
            <v-flex md4 xs12>
              <v-text-field
                :elevation="0"
                flat
                hide-details
                placeholder="Date of Birth (YYYY-MM-DD)"
                prepend-inner-icon="mdi-calendar"
                solo
                v-model="dob"
              ></v-text-field>
            </v-flex>
            <v-btn color="primary" class="mt-1 ml-2" @click="checkNid" :loading="loading">Check NID</v-btn>
          </v-layout>

          <v-card-text>
            <v-layout row wrap ml-2 v-if="hasNidDetail">
              <v-flex xs12>
                <confirmation-header-text text="NID Details" icon="mdi-account-card-details"/>
              </v-flex>

              <v-flex md4 xs12 v-for="(value, key) in nidDetail" :key="key">
                <list-item-detail
                  :sub_title="formatValue(value)"
                  :title="formatLabel(key)"
                  :show-tooltip="true"
                />
              </v-flex>
            </v-layout>

            <v-layout row wrap ml-2 v-else-if="searched && !loading">
              <v-flex xs12>
                <v-alert type="info" outlined dense>
                  No NID details found for the provided NID and DOB.
                </v-alert>
              </v-flex>
            </v-layout>
          </v-card-text>

        </v-card>
      </v-flex>


    </v-layout>
  </v-container>
</template>

<script>

import {VERSIONED_API_URL} from "../../config/config";
import ListItemDetail from "../../components/ListItemDetail";
import Http from 'axios';
import ConfirmationHeaderText from "../../components/ConfirmationHeaderText";

export default {
  name: "NidCheck",
  data() {
    return {
      nid: null,
      dob: null,
      loading: false,
      searched: false,
      nidDetail: null,
    }
  },
  components: {
    ConfirmationHeaderText,
    ListItemDetail,
  },
  computed: {
    hasNidDetail() {
      return !!this.nidDetail && Object.keys(this.nidDetail).length > 0;
    },
  },
  methods: {
    checkNid() {
      if (!this.nid || !this.dob) {
        this.$store.commit('Notification/showError', 'Please enter valid NID number and DOB');
        return;
      }

      this.searched = true;
      this.loading = true;
      this.nidDetail = null;

      Http.get(`${VERSIONED_API_URL}/nid-detail/${encodeURIComponent(this.nid)}/${encodeURIComponent(this.dob)}`)
            .then((res) => {
                this.nidDetail = res.data.nid_detail || null;
                this.$store.commit('Notification/showSuccess', 'NID detail fetched successfully');
        })
            .catch((e) => {
                const message = e && e.response && e.response.data && e.response.data.message
                  ? e.response.data.message
                  : 'Unable to fetch NID details';
                this.$store.commit('Notification/showError', message);
            })
            .finally(() => {
              this.loading = false;
            });
    },
    formatLabel(key) {
      if (!key) {
        return '';
      }

      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/_/g, ' ')
        .replace(/^./, (str) => str.toUpperCase());
    },
    formatValue(value) {
      if (value === null || value === undefined || value === '') {
        return 'N/A';
      }

      if (typeof value === 'object') {
        return JSON.stringify(value);
      }

      return String(value);
    },
  },
}
</script>

<style scoped>

</style>
